<template>
  <router-view />
</template>

<script>
export default {
  name: 'TransferIndex'
}
</script>
